import React, { CSSProperties } from "react";

interface NavLogoExportProps {
  logoText?: string;
  logoUrl?: string;
  linkUrl?: string;
  fontSize?: number;
  height?: number;
}

export const NavLogoExport: React.FC<NavLogoExportProps> = ({
  logoText = "Clinic",
  logoUrl,
  linkUrl = "/",
  fontSize = 20,
  height = 40,
}) => {
  const linkStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textDecoration: "none",
    color: "inherit",
    flexShrink: 0,
  };

  return (
    <a href={linkUrl} className="nav-logo" style={linkStyle}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={logoText}
          style={{
            height: `${height}px`,
            width: "auto",
          }}
        />
      ) : (
        <span
          style={{
            fontSize: `${fontSize}px`,
            fontWeight: 700,
            color: "inherit",
          }}
        >
          {logoText}
        </span>
      )}
    </a>
  );
};
